import { getWithParamsRequest, postRequestWithFormData } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export async function getFailedRecordsFile(
  fileId: number,
  type: 'rider' | 'location' | 'school',
  signal?: AbortSignal
): Promise<ApiResponse> {
  return getWithParamsRequest(
    `batch_upload_files/${fileId}/download_errors_file`,
    { batchUploadFileType: type },
    signal
  );
}

export async function getOriginalFile(
  fileId: number,
  type: 'rider' | 'location' | 'school',
  signal?: AbortSignal
): Promise<ApiResponse> {
  return getWithParamsRequest(
    `batch_upload_files/${fileId}/download_uploaded_file`,
    { batchUploadFileType: type },
    signal
  );
}

export async function getTemplateFile(
  payload: { batchUploadFileType: string },
  signal?: AbortSignal
): Promise<ApiResponse> {
  return getWithParamsRequest('batch_upload_files/download_template', payload, signal);
}

export async function batchUploadCsv(payload: { batchUploadFileType: string; file: BinaryType }): Promise<ApiResponse> {
  return postRequestWithFormData('batch_upload_files', payload);
}

export async function getBatchUploadLog(
  payload: {
    page: number;
    perPage: number;
    batchUploadFileType: string;
  },
  signal: AbortSignal
): Promise<ApiResponse> {
  return getWithParamsRequest('batch_upload_files', payload, signal);
}
